import type { RootState } from '../index'

export const selectTaskActivity = (state: RootState, taskId: string) =>
    state.activity.byTaskId[taskId] ?? []

export const selectTaskActivityLoading = (state: RootState, taskId: string) =>
    state.activity.loadingTaskIds.includes(taskId)

export const selectProjectActivity = (state: RootState, projectId: string) =>
    state.activity.byProjectId[projectId]?.events ?? []

export const selectProjectActivityHasMore = (state: RootState, projectId: string) =>
    state.activity.byProjectId[projectId]?.hasMore ?? false

export const selectProjectActivityLoading = (state: RootState, projectId: string) =>
    state.activity.loadingProjectIds.includes(projectId)

export const selectWorkspaceActivity = (state: RootState) => state.activity.workspaceEvents
export const selectWorkspaceActivityLoading = (state: RootState) => state.activity.workspaceLoading
export const selectWorkspaceActivityHasMore = (state: RootState) => state.activity.workspaceHasMore
